import { render, staticRenderFns } from "./ItemTurnoDetalle.vue?vue&type=template&id=11af1fd3&"
import script from "./ItemTurnoDetalle.vue?vue&type=script&lang=js&"
export * from "./ItemTurnoDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports